import { Breadcrumb, Dropdown } from "antd";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import svg68 from "../../../assets/svg/svg68.svg";
import svg69 from "../../../assets/svg/svg69.svg";

function LeaveHeader({ handleAddLeave }) {
  const navigate = useNavigate();
 
  const settingItemsQuickActions = [
    {
      key: "1",
      label: (
        <Link className="flex  text-[16px] font-sans  !text-lightBlack">
          Export as PDF
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link className="flex  text-[16px] font-sans  !text-lightBlack">
          Export as Excel
        </Link>
      ),
    },
  ];
  return (
    <div className="mt-5">
      <div className="flex lg:flex-row flex-col lg:items-center item-start justify-between">
        <div>
          <div className="heading_1 !justify-start flex">Leaves</div>
          {/* <Breadcrumb
            items={[
              {
                title: (
                  <span
                    className="font-dmSans cursor-pointer "
                    onClick={() => navigate(-1)}
                  >
                    Dashboard
                  </span>
                ),
              },
              {
                title: (
                  <span className="text-lightBlack font-dmSans">Leaves</span>
                ),
              },
            ]}
          /> */}
        </div>
        <div className="flex lg:mt-0 mt-2  gap-x-5 lg:mr-5">
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItemsQuickActions }}
            placement="bottom"
          >
            <div className="w-[150px]">
              <button
                className="cstm-btn !h-[43px] !bg-white !text-[#111827] !text-[14px] !border !border-[#E5E7EB] !font-[400] flex gap-x-2"
                type="submit"
              >
                <img src={svg68} alt={svg68} /> Export{" "}
                <img src={svg69} alt="svg69" />
              </button>
            </div>
          </Dropdown>
          <div className="w-[170px]">
            <button
              onClick={() => handleAddLeave()}
              className="cstm-btn "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  d="M19.5 11H13.5V5C13.5 4.73478 13.3946 4.48043 13.2071 4.29289C13.0196 4.10536 12.7652 4 12.5 4C12.2348 4 11.9804 4.10536 11.7929 4.29289C11.6054 4.48043 11.5 4.73478 11.5 5V11H5.5C5.23478 11 4.98043 11.1054 4.79289 11.2929C4.60536 11.4804 4.5 11.7348 4.5 12C4.5 12.2652 4.60536 12.5196 4.79289 12.7071C4.98043 12.8946 5.23478 13 5.5 13H11.5V19C11.5 19.2652 11.6054 19.5196 11.7929 19.7071C11.9804 19.8946 12.2348 20 12.5 20C12.7652 20 13.0196 19.8946 13.2071 19.7071C13.3946 19.5196 13.5 19.2652 13.5 19V13H19.5C19.7652 13 20.0196 12.8946 20.2071 12.7071C20.3946 12.5196 20.5 12.2652 20.5 12C20.5 11.7348 20.3946 11.4804 20.2071 11.2929C20.0196 11.1054 19.7652 11 19.5 11Z"
                  fill="#FFCD47"
                />
              </svg>
              <span className="ml-1">Add Leave</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeaveHeader;
